import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { Select, MenuItem, FormControl, InputLabel, FormLabel } from '@material-ui/core'
import { TreeSelect } from 'antd'
import 'antd/dist/antd.css'

/**
 * props => options
 * hidePf => true/false 是否隱藏站台選項, default: false
 * hideAllPlatform => true/false 是否隱藏全部站台選項, default: false
 * hidePfSubPf => true/false 是否隱藏平台選項, default: false
 * showAllSubPlatform => true/false 是否顯示全部平台選項, default: false
 */
class PfSubPfMultiSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'PfSubPfMultiSelect', options)
        }
    }

    state = {
        currencyList: [],
        currency: '',
        pfSubPfIDList: [],
        currencyDisabled: false,
        pfSubPfListDisabled: false,
        hidePf: false,
        hidePfSubPf: false,
        hideAllPlatform: false,
        showAllSubPlatform: false,
    }
    /** 依幣別篩選平台列表 */
    handleTreeDataFilter() {
        const subPfDisabledList = this.props?.options?.disabledList ?? []
        const treeData = utils.generatePfTreeData(null, this.props.filterPfSubPfIDList, this.props.showAllPlatform).filter((elem) => {
            return this.state.currency === 'all' ? true : this.state.currency === utils.getPfCurrency(elem.key)
        })
        /** 建立不可變更選取項目 */
        if (treeData.length && subPfDisabledList.length) {
            this.handleMakeDisabledItem(treeData, subPfDisabledList)
        }
        return treeData
    }

    /** 建立不可變更選取項目 */
    handleMakeDisabledItem(treeData, disabledList) {
        treeData.forEach(currency => {
            currency.children.forEach(subPlatform => {
                if (disabledList.includes(subPlatform.value)) {
                    subPlatform['disabled'] = true
                }
            })
        })
    }

    componentDidMount() {
        const currencyList = [] // 整理幣別(站台)類別
        const _tempList = []
        Object.entries(this.props.dataService.pfSubPfMap).forEach(([_pfSubPfID, elem]) => {
            const pfCurrency = utils.getPfCurrency(elem['pf_id'])
            if (!_tempList.includes(pfCurrency)) {
                _tempList.push(pfCurrency)
                currencyList.push(elem.pf_id)
            }
        })

        const sortCurrencyList = utils.sortPlatform(currencyList) // 幣別(站台)排序
        const getPfCurrencyList = sortCurrencyList.map((key)=>{
            return utils.getPfCurrency(key)
        })

        if (this.props.currencyOnChange && typeof this.props.currencyOnChange === 'function') {
            this.props.currencyOnChange(getPfCurrencyList[0])
        }

        const defaultCurrency = this.props?.options?.hideAllPlatform ? getPfCurrencyList[0] : 'all'

        const hidePf = this.props?.options?.hidePf ?? false
        const hidePfSubPf = this.props?.options?.hidePfSubPf ?? false
        const hideAllPlatform = this.props?.options?.hideAllPlatform ?? false
        const showAllSubPlatform = this.props?.options?.showAllSubPlatform ?? false
        const initPfSubPfIDList = this.props.pfSubPfIDList || []

        this.setState({
            currency: defaultCurrency,
            currencyList: getPfCurrencyList,
            pfSubPfIDList: initPfSubPfIDList,
            hidePf,
            hidePfSubPf,
            hideAllPlatform,
            showAllSubPlatform,
        })

        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    render() {
        return (
            <React.Fragment>
                {!this.state.hidePf && <FormControl className={this.props.classes.formControl} disabled={this.state.currencyDisabled}>
                    {!this.props.hideCurrencyTitle && <InputLabel htmlFor="age-simple">{this.t('currency')}</InputLabel>}
                    <Select
                        value={this.state.currency}
                        onChange={(event) => {
                            if (this.props.currencyOnChange && typeof this.props.currencyOnChange === 'function') {
                                this.props.currencyOnChange(event.target.value)
                            }

                            this.setState({
                                currency: event.target.value,
                                pfSubPfIDList: [],
                            })
                        }}>
                        {!this.state.hideAllPlatform && <MenuItem value="all">
                            {this.t('allPlatform')}
                        </MenuItem>}
                        {this.state.currencyList.map((currency, index) => (
                            <MenuItem value={currency} key={`${currency}-${index}`}>
                                {`${this.t('Currency.' + currency)}`}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>}
                {!this.state.hidePfSubPf && <FormControl
                    className={this.props.classes.formControl}
                    disabled={this.state.pfSubPfListDisabled}>
                    {!this.props.hidePfSubPfTitle && <FormLabel className={this.props.classes.shrink}>{this.t('pfSubPf')}</FormLabel>}
                    <TreeSelect
                        className={this.props.classes.treeSelect}
                        treeData={
                            this.state.showAllSubPlatform ? 
                            [
                                {
                                    title: this.t('allSubPlatform'),
                                    key: 'all',
                                    value: 'all',
                                    children: this.handleTreeDataFilter()
                                } 
                            ] :
                            this.handleTreeDataFilter()
                        }
                        value={this.state.pfSubPfIDList}
                        onChange={(value) => {
                            this.setState({
                                pfSubPfIDList: value,
                            })

                            if (this.props.checkValue) {
                                this.props.checkValue(value)
                            }
                        }}
                        disabled={this.state.pfSubPfListDisabled}
                        maxTagCount={1}
                        treeCheckable={true}
                        showSearch={true}
                        listHeight={64}
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        searchPlaceholder={this.t('pleaseSelect')}
                        dropdownStyle={{ zIndex: 3000 }}
                        getPopupContainer={()=>{
                            return document.getElementById('treeSelectBox')
                        }}
                    />
                </FormControl>}
            </React.Fragment>
        )
    }
}

PfSubPfMultiSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    dataService: PropTypes.object,
    options: PropTypes.object,
    filterPfSubPfIDList: PropTypes.array,
    currencyOnChange: PropTypes.func,
    showAllPlatform: PropTypes.bool,
    pfSubPfIDList: PropTypes.array,
    checkValue: PropTypes.func,
    hideCurrencyTitle: PropTypes.bool,
    hidePfSubPfTitle: PropTypes.bool,
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        treeSelect: {
            width: '240px',
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
        },
        hide: {
            display: 'none',
        },
    }
}

export default hoc(styles)(PfSubPfMultiSelect)
